import { Container, Label, Overlay, Panel } from '@playcanvas/pcui';

import { localize } from './localization';

const shortcutList = [
    { header: 'movement' },
    { key: 'W / ↑', action: 'move-forward' },
    { key: 'S / ↓', action: 'move-backward' },
    { key: 'A / ←', action: 'move-left' },
    { key: 'D / →', action: 'move-right' },
    { key: 'E', action: 'move-up' },
    { key: 'Q', action: 'move-down' },
    { key: 'Shift + Movement', action: 'move-fast' },
    { key: 'Ctrl + Movement', action: 'move-slow' },
    { header: 'camera' },
    { key: 'Mouse Wheel', action: 'zoom' },
    { key: 'Shift + Wheel', action: 'pan' },
    { key: 'Ctrl + Wheel', action: 'zoom-fast' },
    { key: 'Left Mouse Drag', action: 'orbit' },
    { key: 'Double Click', action: 'focus-point' },
    { header: 'other' },
    { key: 'M', action: 'toggle-camera-mode' },
    { key: 'G', action: 'toggle-grid' },
    { key: 'C', action: 'toggle-gizmo-coordinate-space' }
];

class ShortcutsPopup extends Overlay {
    constructor(args = {}) {
        args = {
            ...args,
            id: 'shortcuts-popup',
            clickable: true,
            hidden: true
        };

        super(args);

        const shortcutsContainer = new Container({
            id: 'shortcuts-container'
        });

        shortcutList.forEach((shortcut) => {
            if (shortcut.header) {
                const label = new Label({
                    class: 'shortcut-header-label',
                    text: localize(`shortcuts.${shortcut.header}`)
                });

                const entry = new Container({
                    class: 'shortcut-header'
                });

                entry.append(label);

                shortcutsContainer.append(entry);
            } else {
                const key = new Label({
                    class: 'shortcut-key',
                    text: shortcut.key
                });

                const action = new Label({
                    class: 'shortcut-action',
                    text: localize(`shortcuts.${shortcut.action}`)
                });

                const entry = new Container({
                    class: 'shortcut-entry'
                });

                entry.append(key);
                entry.append(action);

                shortcutsContainer.append(entry);
            }
        });

        const shortcutsPanel = new Panel({
            id: 'shortcuts-panel',
            headerText: localize('shortcuts.title')
        });

        shortcutsPanel.append(shortcutsContainer);

        this.append(shortcutsPanel);
    }
}

export { ShortcutsPopup };
